<script>
import getSecret from '@utils/get-secret'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

export default {
  page: {
    title: 'Inicio',
    meta: [{ name: 'description', content: getSecret('DESCRIPTION') }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: '<i class="fas fa-home"></i> Inicio',
      items: [
        {
          text: 'Inicio',
          active: true
        }
      ],
    }
  },
}
</script>

<template> 
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />

    <div class="row">
      <div class="col-md-12">
        <b-card>
          Esta es la página de Inicio
        </b-card>
      </div>
    </div>
  </Layout>
</template>
